export default __webpack_public_path__ + "static/media/opensans-extrabold-webfont.1531e15f.woff";